import { useCallback } from "../imports";
import { AUTH_EVENTS, AUTH_CHANNEL_NAME } from "../constants/authConstants";

export const useAuthActions = () => {
  const notifyLogout = useCallback(() => {
    if (typeof window !== "undefined" && "BroadcastChannel" in window) {
      const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
      channel.postMessage({ type: AUTH_EVENTS.LOGOUT });
      channel.close();
    }

    localStorage.setItem("wasLoggedOut", "true");
    setTimeout(() => {
      localStorage.removeItem("wasLoggedOut");
    }, 1500);
  }, []);

  const notifyLogin = useCallback(() => {
    if (typeof window !== "undefined" && "BroadcastChannel" in window) {
      const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
      channel.postMessage({ type: AUTH_EVENTS.LOGIN });
      channel.close();
    }
  }, []);

  const notifyRefresh = useCallback(() => {
    if (typeof window !== "undefined" && "BroadcastChannel" in window) {
      const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
      channel.postMessage({ type: AUTH_EVENTS.REFRESH });
      channel.close();
    }
  }, []);

  return {
    notifyLogout,
    notifyLogin,
    notifyRefresh,
  };
};
